<script>
export default {
    name: 'IconShare',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-share"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M48 8a8 8 0 11-6.271 12.968L23.685 29.77c.205.708.315 1.456.315 2.23 0 .79-.114 1.553-.328 2.273L41.7 43.068a8 8 0 11-1.601 3.669l-18.5-9.023a8 8 0 11.033-11.394l18.475-9.011A8 8 0 0148 8z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
